import { reducer as ReportsReducer } from './Reports/reducer'
import ReportsState from './Reports/ReportsState'
import SettingsState from './Settings/SettingsState'
import { reducer as SystemReducer } from './System/reducer'
import { reducer as UserReducer } from './User/reducer'
import { reducer as SettingsReducer } from './Settings/reducer'
import UserState from './User/UserState'

export interface ApplicationState {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    system: any
    user: UserState
    reports: ReportsState
    settings: SettingsState
}

export const reducers = {
    system: SystemReducer,
    user: UserReducer,
    reports: ReportsReducer,
    settings: SettingsReducer
}

export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void
}
